function ceilToStep(value: number, step: number): number {
  return Math.ceil(value / step) * step;
}

export function maintainRatio(x: number, y: number, isMetricValue: boolean): { x: number; y: number } {
  const ratio = isMetricValue ? 0.1 : 10;

  let scaleX = Math.max(x, y / ratio);
  scaleX = ceilToStep(scaleX, 5);
  if (scaleX < 15) scaleX = 15;

  const scaleY = scaleX * ratio;

  return {
    x: scaleX,
    y: scaleY,
  };
}

export function sortNestedArray(arr: any[][], soilType: string): any[][] {
  if (soilType === 'nativesoil') {
    return arr.map((subArray: any) => [...subArray].sort((a: any, b: any) => a.sampleId.localeCompare(b.sampleId)));
  }
  return arr.map((subArray: any) => [...subArray].sort((a: any, b: any) => a.sampleType.localeCompare(b.sampleType)));
}
